const translations = {
    'battle.report.title': 'Battle Report',
    'battle.report.missing': 'Battle report not found.',
    'battle.report.summary': 'Summary',
    'battle.report.tile': 'Tile: %s',
    'battle.report.result': 'Result: %s',
    'battle.report.losses': 'Losses: %d vs %d',
    'battle.report.rounds': 'Rounds',
    'battle.report.roundsNone': 'No rounds recorded.',
    'battle.report.roundLabel': 'Round %d',
    'battle.report.roundDetail': 'Kills %d/%d • Remaining %d/%d',
    'battle.result.attacker': 'Victory',
    'battle.result.defender': 'Defeat',
    'battle.result.draw': 'Draw',
    'unit.militia': 'Militia',
    'enemy.bandits': 'Bandits',
    'enemy.goblins': 'Goblins',
    'enemy.orcs': 'Orcs',
};

export default translations;
